export function getSafeFrame(frame: number, videoDurationInFrames: number): number {
    return Math.max(0, Math.min(frame, videoDurationInFrames-1));
}
